// Indian ports of arrival
export const indianPorts = [
    "AGATTI SEAPORT",
    "AHMEDABAD AIRPORT",
    "AMRITSAR AIRPORT",
    "BAGDOGRA AIRPORT",
    "BENGALURU AIRPORT",
    "BHUBANESHWAR AIRPORT",
    "CALICUT AIRPORT",
    "CALICUT SEAPORT",
    "CHANDIGARH AIRPORT",
    "CHENNAI AIRPORT",
    "CHENNAI SEAPORT",
    "COCHIN AIRPORT",
    "COCHIN SEAPORT",
    "COIMBATORE AIRPORT",
    "DELHI AIRPORT",
    "GAYA AIRPORT",
    "GOA AIRPORT (DABOLIM)",
    "GOA AIRPORT (MOPA)",
    "GOA SEAPORT",
    "GUWAHATI AIRPORT",
    "HYDERABAD AIRPORT",
    "INDORE AIRPORT",
    "JAIPUR AIRPORT",
    "KAMARAJAR SEAPORT",
    "KANDLA SEAPORT",
    "KANNUR AIRPORT",
    "KATTUPALI SEAPORT",
    "KOLKATA AIRPORT",
    "KOLKATA SEAPORT",
    "LUCKNOW AIRPORT",
    "MADURAI AIRPORT",
    "MANGALORE AIRPORT",
    "MANGALORE SEAPORT",
    "MUMBAI AIRPORT",
    "MUMBAI SEAPORT",
    "MUNDRA SEAPORT",
    "NAGPUR AIRPORT",
    "NHAVA SHEVA SEAPORT",
    "PORT BLAIR AIRPORT",
    "PORT BLAIR SEAPORT",
    "PUNE AIRPORT",
    "RAXAUL LANDPORT",
    "RUPAIDIHA LANDPORT",
    "SURAT AIRPORT",
    "TIRUCHIRAPALLI AIRPORT",
    "TRIVANDRUM AIRPORT",
    "VALLARPADAM SEAPORT",
    "VARANASI AIRPORT",
    "VIJAYAWADA AIRPORT",
    "VISHAKHAPATNAM AIRPORT",
    "VISHAKHAPATNAM SEAPORT"
  ];

  // Country codes for phone (E.164); +94 Sri Lanka as default
export const PHONE_COUNTRY_CODES = [
    { value: "+94", label: "🇱🇰 +94" },
    { value: "+91", label: "🇮🇳 +91" },
    { value: "+1", label: "🇺🇸 +1" },
    { value: "+44", label: "🇬🇧 +44" },
    { value: "+61", label: "🇦🇺 +61" },
    { value: "+971", label: "🇦🇪 +971" },
    { value: "+65", label: "🇸🇬 +65" },
    { value: "+60", label: "🇲🇾 +60" },
    { value: "+66", label: "🇹🇭 +66" },
    { value: "+81", label: "🇯🇵 +81" },
    { value: "+86", label: "🇨🇳 +86" },
    { value: "+49", label: "🇩🇪 +49" },
    { value: "+33", label: "🇫🇷 +33" },
    { value: "+39", label: "🇮🇹 +39" },
    { value: "+34", label: "🇪🇸 +34" },
    { value: "+27", label: "🇿🇦 +27" },
    { value: "+55", label: "🇧🇷 +55" },
    { value: "+52", label: "🇲🇽 +52" },
  ]as const;


  // Education levels
 export const educationLevels = [
    "BELOW MATRICULATION",
    "GRADUATE",
    "HIGHER SECONDARY",
    "ILLITERATE",
    "MATRICULATION",
    "NA BEING MINOR",
    "OTHERS",
    "POST GRADUATE",
    "PROFESSIONAL"
  ];

  // Religions
  export const religions = [
    "BAHAI",
    "BUDDHISM",
    "CHRISTIAN",
    "HINDU",
    "ISLAM",
    "JAINISM",
    "JUDAISM",
    "OTHERS",
    "PARSI",
    "SIKH",
    "ZOROASTRIAN"
  ];

  // eBusiness: which document types are required per purpose (saved as {document_type}.pdf)
export const EBUSINESS_PURPOSE_TO_DOC_TYPES: Record<string, string[]> = {
  SET_UP_BUSINESS_VENTURE: ["BUSINESS_INVITATION", "BUSINESS_CARD"],
  SALE_PURCHASE_TRADE: ["BUSINESS_INVITATION", "BUSINESS_CARD"],
  ATTEND_BUSINESS_MEETINGS: ["BUSINESS_INVITATION", "BUSINESS_CARD"],
  TO_RECRUIT_MANPOWER: ["BUSINESS_INVITATION", "BUSINESS_CARD"],
  EXHIBITIONS_TRADE_FAIRS: ["BUSINESS_INVITATION", "BUSINESS_CARD"],
  EXPERT_SPECIALIST_PROJECT: ["BUSINESS_INVITATION", "BUSINESS_CARD"],
  CONDUCTING_TOURS: ["BUSINESS_INVITATION", "BUSINESS_CARD"],
  GIAN_LECTURES: ["GIAN_INVITATION", "GIAN_SANCTION_ORDER", "GIAN_SYNOPSIS"],
  SPORTS_RELATED_ACTIVITY: ["SPORTS_APPROVAL", "SPORTS_INVITATION_LETTER"],
  TO_JOIN_THE_VESSEL: ["VESSEL_SPONSORING_LETTER", "VESSEL_CDC"],
};
  
// eBusiness travel purpose slugs (saved in DB). Labels and popup messages come from i18n (t).
export const EBUSINESS_PURPOSE_SLUGS = [
  "SET_UP_BUSINESS_VENTURE",
  "SALE_PURCHASE_TRADE",
  "ATTEND_BUSINESS_MEETINGS",
  "TO_RECRUIT_MANPOWER",
  "EXHIBITIONS_TRADE_FAIRS",
  "EXPERT_SPECIALIST_PROJECT",
  "CONDUCTING_TOURS",
  "GIAN_LECTURES",
  "SPORTS_RELATED_ACTIVITY",
  "TO_JOIN_THE_VESSEL",
] as const;